<template>
    <div id="transplantation-component">
        <div class="card mb-4 shadow-sm">
            <h2 ref="header-form" class="h3 text-center text-primary text-uppercase py-3 border-bottom border-primary">
                <i class="fa fa-pencil-alt"></i> Registro de tipo de trasplante
            </h2>
            <div class="card-body">
                <form-errors :errors="errors"></form-errors>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6">
                        <div class="mb-3">
                            <label for="name" class="form-label">
                                Nombre <span class="text-danger">*</span>
                            </label>
                            <input id="name" class="form-control" type="text" placeholder="Nombre" tabindex="1"
                                v-model="record.name" />
                        </div>
                        <div class="mb-3">
                            <label for="prefix" class="form-label">
                                Prefijo <span class="text-danger">*</span>
                            </label>
                            <input id="prefix" class="form-control" type="text" placeholder="Prefijo"
                                tabindex="2" v-model="record.prefix" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-outline-primary-dark" type="reset" @click="reset()">
                    Limpiar
                </button>
                <button class="btn btn-primary" type="button" @click="setRecord('global-data'), documents_required = false, document = ''">
                    <i class="fa fa-save"></i>
                    Guardar
                </button>
            </div>
        </div>
        <div class="card mb-4 shadow-sm">
            <h2 class="h3 text-center text-primary text-uppercase py-3 border-bottom border-primary">
                <i class="fa fa-book"></i> Lista de tipos de trasplante
            </h2>
            <div class="card-body">
                <v-client-table :columns="columns" :data="records" :options="table_options">
                <div slot="id" slot-scope="props" class="main-flex-buttons">
                    <div v-if="isNotEditable(props.row.id)">
                        <button class="btn btn-outline-primary" type="button" title="Editar registro"
                            @click="getRecord('global-data', props.row.id); scrollMeTo('header-form');">
                            <i class="fa fa-edit"></i>
                        </button>
                    </div>
                    <!--div v-if="isNotEditable(props.row.id)">
                        <button class="btn btn-outline-danger" type="button" title="Eliminar registro"
                            @click="deleteRecordFiltered('global-data', url, props.row.id)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div-->
                </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // Roles con permisos de acceder al componente.
                allowedRoles: [
                    "ADM",  // Administrador
                ],
                errors: [],
                records: [],
                documents_required: false,
                document: '',
                record: {
                    prefix: '',
                    name: '',
                    description: '',
                    document_types: [],
                    type: 'transplantation-type',
                },
                url: 'global-data-type/transplantation-type',
                columns: [
                    'name',
                    'prefix',
                    'id'
                ],
            }
        },
        methods: {

            /**
             * Método para determinar si un tipo de traspante es editable y/o se puede eliminar
             * @param {int} id Identificador del tipo de trasplante
             */
             isNotEditable(id) {
                const vm = this;
                let not_editable = [28, 29, 30, 31, 32, 33, 34, 35];
                return !not_editable.includes(id);
            },

            /**
             * Método para reestablecer valores iniciales del formulario
             *
             * @method reset
             *
             * @author Angelo Osorio <adosorio@cenditel.gob.ve> | <kingangelo_123@gmail.com>
             * @author Ing. Roldan Vargas <rvargas@cenditel.gob.ve> | <roldandvg@gmail.com>
             */
            reset() {
                const vm = this;
                vm.errors = [];
                vm.document = '';
                vm.documents_required = false,
                vm.record = {
                    prefix: '',
                    name: '',
                    type: 'transplantation-type',
                    description: '',
                    document_types: []
                }
            },

            /**
            * Método que carga un documento a la lista de documentos requeridos
            *
            * @method addDoc
            *
            * @author  Luis Ramírez <lgramirez@cenditel.gob.ve>
            *
            * @param  {String}  document nombre del documento
            *
            */
            addDoc(document) {
                const vm = this;
                if (document.trim() !== "") {
                vm.record.document_types = (vm.record.document_types)??[];
                vm.record.document_types.push(document);
                vm.document = "";
                }
            },

            /**
            * Método que cambia el estilo del elemento seleccionado para eliminar
            *
            * @method addDoc
            *
            * @author  Luis Ramírez <lgramirez@cenditel.gob.ve>
            *
            * @param  index indice del elemento a seleccionado
            *
            */
            hover(index) {
                let element= document.getElementById(index);
                element.classList.add('border', 'rounded', 'border-danger', 'p-2')
                setTimeout(function(){
                    element.classList.remove('border', 'rounded', 'border-danger', 'p-2')
                }, 1000);
            },

            /**
            * Método que elimina un documento de la lista de documentos requeridos
            *
            * @method deleteDoc
            *
            * @author  Luis Ramírez <lgramirez@cenditel.gob.ve>
            *
            * @param  index indice del elemento a eliminar del arreglo
            *
            */
            deleteDoc(index){
                const vm= this;
                vm.record.document_types.splice(index, 1);
            }
        },

        created() {
            this.table_options.headings = {
                'prefix': 'Prefijo',
                'name': 'Nombre',
                'type': 'Tipo',
                'id': 'Acción'
            };
            this.table_options.sortable = ['name', 'prefix'];
            this.table_options.filterable = ['name', 'prefix'];
            this.table_options.columnsClasses = {
                'id': 'col-2 text-center'
            };
        },

        async mounted() {
            const vm = this;
            // Obtener el rol del usuario autenticado
            vm.user_role = vm.$parent.user.role;

            // Verficación de roles que pueden acceder al componente.
            if (vm.allowedRoles.includes(vm.user_role)) {
                vm.loadingState(true); // Inicio de spinner de carga.
                await vm.getRecords(vm.url, 'records');
                vm.loadingState(); // Finaliza spinner de carga.
            }
            else {
                location.href = '/';
            }
        }
    };
</script>
